import React, { useState, useEffect, useContext } from "react";
import {
    getDevice,
    saveDevice,
    getZones,
    deleteDevice,
    getDeviceLinkedZones,
    addZoneWithDevice,
    removeZoneWithDevice,
    saveChannel,
    getDeviceProfiles,
} from "../../services/RepositoryService";
import StarekContext from "../../context/StarekContext";
import { longDateString } from "../../utils";
import { useParams, useNavigate } from "react-router-dom";
import { confirm } from "../../components/Confirmation";
import { constants } from "../../constants";
import Paper from "@mui/material/Paper";
import IonRangeSlider from "react-ion-slider";
import {
    Grid,
    Table,
    TableHeaderRow,
    TableFilterRow,
    PagingPanel,
    TableColumnResizing,
    Toolbar,
    TableSelection,
    TableColumnVisibility,
    ColumnChooser,
    TableEditColumn,
} from "@devexpress/dx-react-grid-material-ui";
import {
    SelectionState,
    FilteringState,
    IntegratedFiltering,
    SortingState,
    PagingState,
    IntegratedPaging,
    IntegratedSelection,
    IntegratedSorting,
} from "@devexpress/dx-react-grid";
import Spinner from "../../components/Spinner";
import SignalCalibrationWizard from "../../components/Wizards/SignalCalibrationWizard";
const Device = (props) => {
    const context = useContext(StarekContext);
    const navigator = useNavigate();

    const { id } = useParams();

    const [item, setItem] = useState({});
    const [isAdding, setIsAdding] = useState(false);
    const [signalUnderCalibration, setSignalUnderCalibration] = useState(null);

    const [disableClose, setDisableClose] = useState(false);
    const [zoneId, setZoneId] = useState(0);
    const [unlinkedZones, setUnlinkedZones] = useState([]);
    const [linkedZones, setLinkedZones] = useState([]);
    const [editZone, setEditZone] = useState(true);
    const [channels, setChannels] = useState([]);
    const [channelArray, setChannelArray] = useState([]);
    const [channelNameArray, setChannelNameArray] = useState([]);
    const [showMessage, setShowMessage] = useState(false);
    const [message, setMessage] = useState("");
    const [showError, setShowError] = useState(false);
    const [selected, setSelected] = useState();
    const [columns, setColumns] = useState([
        { name: "name", title: "Name" },
        { name: "delete", title: "Delete" },
    ]);
    const [pageSizes] = useState([5, 10, 20]);
    const [defaultColumnWidths] = useState([
        { columnName: "name", width: 400 },
        { columnName: "delete", width: 400 },
    ]);
    const [defaultHiddenColumnNames] = useState(["Priority", "Completion"]);
    const [tableColumnExtensions] = useState([
        { columnName: "delete", align: "right" },
    ]);
    const [showFilter] = useState(false);
    const [selectedC, setSelectedC] = useState();
    const [columnsC, setColumnsC] = useState([
        { name: "signal", title: "Signal" },
        { name: "name", title: "Name" },
        { name: "attributes", title: "Spectrum" },
        { name: "color", title: "Color" },
    ]);
    const [pageSizesC] = useState([5, 10, 20]);
    const [defaultColumnWidthsC] = useState([
        { columnName: "signal", width: 200 },
        { columnName: "name", width: 300 },
        { columnName: "attributes", width: 750 },
        { columnName: "color", width: 75 },
    ]);
    const [defaultHiddenColumnNamesC] = useState(["Priority", "Completion"]);
    const [tableColumnExtensionsC] = useState([
        { columnName: "delete", align: "left" },
    ]);
    const [showFilterC] = useState(false);
    const [deviceProfiles, setDeviceProfiles] = useState([]);
    const [loadingPrimary, setLoadingPrimary] = useState(true);

    useEffect(() => {
        if (id == null || id <= 0) {
            setLoadingPrimary(false);
            return;
        }
        const includes = ["channels", "zones", "created_by", "updated_by"];
        (async () => {
            const device = await getDevice(
                context.activePlant.id,
                id,
                includes
            );
            await getLinkedZones();
            setItem(device);
            setChannels(device.channels);
            console.log("device.channels =>", device.channels);
            fillChannelArray(device.channels);
            setLoadingPrimary(false);
        })();
    }, []);

    useEffect(() => {
        (async () => {
            const deviceProfiles = await getDeviceProfiles(
                context.activePlant.id
            );
            setDeviceProfiles(deviceProfiles);
        })();
    }, []);

    const TableCell = (props) => {
        const { row, column } = props;
        const navigator = useNavigate();
        if (column.name === "delete") {
            return (
                <Table.Cell
                    {...props}
                    onClick={() => {
                        handleRemoveZoneWithDevice(row.id, row.name);
                    }}
                >
                    <i className="nav-icon fa fa-trash text-danger" />
                </Table.Cell>
            );
        }
        return <Table.Cell {...props} />;
    };

    const TableCellC = (props) => {
        const { row, column } = props;
        const navigator = useNavigate();
        if (column.name === "signal") {
            return (
                <Table.Cell {...props}>
                    <div>{row?.signal}</div>
                    {(() => {
                        if (row.type === 0) {
                            return (
                                <span className="badge badge-danger">
                                    Unprovisioned
                                </span>
                            );
                        } else {
                            return (
                                <>
                                    {row.is_analog && (
                                        <span className="badge badge-secondary mr-2">
                                            <i class="fa fa-tachometer-alt"></i>
                                        </span>
                                    )}
                                    {row.is_digital && (
                                        <span className="badge badge-secondary mr-2">
                                            <i class="fa fa-wave-square"></i>
                                        </span>
                                    )}
                                    {row.is_input && (
                                        <span className="badge badge-dark mr-2">
                                            <i class="fa fa-sign-in-alt"></i>
                                        </span>
                                    )}
                                    {row.is_output && (
                                        <span className="badge badge-dark mr-2">
                                            <i class="fa fa-sign-out-alt"></i>
                                        </span>
                                    )}
                                </>
                            );
                        }
                    })()}
                </Table.Cell>
            );
        } else if (column.name === "name") {
            return (
                <Table.Cell {...props}>
                    {(() => {
                        if (row.type === 0) {
                            return <></>;
                        } else {
                            return (
                                <>
                                    <div class="input-group input-group-sm mr-10">
                                        <span class="input-group-prepend">
                                            <button
                                                type="button"
                                                class="btn btn-light btn-flat"
                                                title="Invert Datapoints"
                                            >
                                                <i className="fa fa-adjust"></i>
                                            </button>
                                        </span>
                                        <span class="input-group-prepend">
                                            <button
                                                type="button"
                                                class="btn btn-light btn-flat"
                                                title="Mark Auxiliary"
                                            >
                                                <i className="fa fa-coins"></i>
                                            </button>
                                        </span>
                                        <span class="input-group-prepend">
                                            <button
                                                type="button"
                                                class="btn btn-info btn-flat"
                                                title="Setup Calibration"
                                                onClick={() => {
                                                    setSignalUnderCalibration(
                                                        row
                                                    );
                                                }}
                                            >
                                                <i className="fa fa-wrench"></i>
                                            </button>
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id={row.id}
                                            name={"channel_" + row.id}
                                            defaultValue={
                                                channelNameArray[
                                                    "channel_" + row.id
                                                ]
                                            }
                                            onBlur={handleChannelName}
                                            disabled={row.type == 0}
                                        ></input>
                                        <span class="input-group-append">
                                            <button
                                                type="button"
                                                class="btn btn-warning btn-flat"
                                                title="Update Name"
                                            >
                                                <i className="fa fa-save"></i>
                                            </button>
                                        </span>
                                    </div>
                                </>
                            );
                        }
                    })()}
                </Table.Cell>
            );
        } else if (column.name === "calibration") {
            return (
                <Table.Cell {...props}>
                    {(() => {
                        if (row.type === 0) {
                            return <></>;
                        } else {
                            return <></>;
                        }
                    })()}
                </Table.Cell>
            );
        } else if (column.name === "attributes") {
            return (
                <Table.Cell {...props}>
                    {(() => {
                        if (row.type === 0) {
                            return <></>;
                        } else {
                            return (
                                <>
                                    {row.is_auxiliary && (
                                        <span className="badge badge-info mr-2">
                                            Auxiliary
                                        </span>
                                    )}
                                    {row.is_inverted && (
                                        <span className="badge badge-info mr-2">
                                            Inverted
                                        </span>
                                    )}

                                    <IonRangeSlider
                                        skin={"flat"}
                                        force_edges
                                        type={"double"}
                                        min={0}
                                        max={1023}
                                        from_fixed={true}
                                        to_fixed={true}
                                        from={row.min_value_ever || 0}
                                        to={row?.max_value_ever || 0}
                                        onStart={(data) => {
                                            if (row.is_analog) {
                                                return;
                                            }
                                            const min =
                                                row.min_value_ever; /** TODO - get from calibration */
                                            const max =
                                                row.max_value_ever; /** TODO - get from calibration */
                                            const range = max - min;
                                            const lowWidth =
                                                (row.meta.threshold.min *
                                                    range) /
                                                1023;
                                            const lowLeft = (min / 1023) * 100;
                                            const highWidth =
                                                ((100 -
                                                    row.meta.threshold.max) *
                                                    range) /
                                                1023;
                                            const highLeft =
                                                (max / 1023) * 100 - highWidth;
                                            if (
                                                row.meta?.threshold?.min !== 0
                                            ) {
                                                data.slider.append(
                                                    "<div style='display:block;position:absolute;top:18px;left:" +
                                                        lowLeft +
                                                        "%;width:" +
                                                        lowWidth +
                                                        "%;border:1px dashed #88f;height:24px;'></div>"
                                                );
                                                data.slider.append(
                                                    "<div style='display:block;position:absolute;top:18px;left:" +
                                                        highLeft +
                                                        "%;width:" +
                                                        highWidth +
                                                        "%;border:1px dashed #f88;height:24px;'></div>"
                                                );
                                            }
                                        }}
                                    />
                                </>
                            );
                        }
                    })()}
                </Table.Cell>
            );
        } else if (column.name === "color") {
            return (
                <Table.Cell {...props}>
                    {(() => {
                        if (row.type === 0) {
                            return <></>;
                        } else {
                            return (
                                <>
                                    <input
                                        type="color"
                                        defaultValue={row?.style?.color}
                                    ></input>
                                </>
                            );
                        }
                    })()}
                </Table.Cell>
            );
        }
        return <Table.Cell {...props} />;
    };

    const fillChannelArray = (channels) => {
        if (channels) {
            var channelArray = {};
            var channelNameArray = {};
            channels.map((value, index) => {
                channelArray["reported_inverted_" + value.id] =
                    value.is_reported_inverted;
                channelArray["reported_report_" + value.id] =
                    value.is_reported_with_report;
                channelArray["reported_device_" + value.id] =
                    value.is_reported_with_device;
                channelArray["reported_auxillary_" + value.id] =
                    value.is_reported_auxillary;

                channelNameArray["channel_" + value.id] = value.name;
            });
            setChannelArray(channelArray);
            setChannelNameArray(channelNameArray);
        }
    };

    const handleAddZoneWithDevice = async (event) => {
        event.preventDefault();
        if (zoneId <= 0) {
            setMessage("Please select zone to link with device");
            setShowError(true);
            setShowMessage(true);
            return false;
        }

        let zoneData = {
            payload: {
                add: [{ zone_id: parseInt(zoneId) }],
                remove: [],
            },
        };

        const response = await addZoneWithDevice(
            context.activePlant.id,
            item.id,
            zoneData
        );
        if (response) {
            setMessage("Zone added.");
            setShowMessage(true);
            await getLinkedZones();
            setZoneId(0);
        }
    };

    const handleRemoveZoneWithDevice = async (id, name) => {
        if (
            (await confirm(`Are you sure you want to delete this zone?`)) ==
            true
        ) {
            let zoneData = {
                payload: {
                    add: [],
                    remove: [{ zone_id: parseInt(id) }],
                },
            };

            const response = await removeZoneWithDevice(
                context.activePlant.id,
                item.id,
                zoneData
            );
            if (response) {
                setMessage("Zone deleted.");
                setShowMessage(true);
                await getLinkedZones();
            }
        }
    };

    const getUnlinkedZones = async (lzs) => {
        const zones = await getZones(context.activePlant.id);
        let uz = zones.filter(
            (item) => !lzs.filter((lz) => lz.id === item.id).length
        );
        setUnlinkedZones(uz);
    };

    const getLinkedZones = async () => {
        const response = await getDeviceLinkedZones(context.activePlant.id, id);
        if (response) {
            setLinkedZones(response);
            getUnlinkedZones(response);
        }
    };

    const handleChannelName = async (event) => {
        const id = event.target.id;
        channelNameArray[event.target.name] = event.target.value;

        let channelData = {
            payload: {
                name: channelNameArray[event.target.name],
            },
        };

        const response = await saveChannel(
            context.activePlant.id,
            item.id,
            id,
            channelData
        );

        setChannelNameArray([]);
        setChannelNameArray(channelNameArray);
    };

    const handleCheckBox = async (event) => {
        const id = event.target.id;
        channelArray[event.target.name] = !channelArray[event.target.name];

        const ri =
            channelArray["reported_inverted_" + id] === true
                ? constants.REPORTED_INVERTED
                : constants.REPORTED_NONE;
        const rr =
            channelArray["reported_report_" + id] === true
                ? constants.REPORTED_REPORT
                : constants.REPORTED_NONE;
        const rd =
            channelArray["reported_device_" + id] === true
                ? constants.REPORTED_DEVICE
                : constants.REPORTED_NONE;
        const ra =
            channelArray["reported_auxillary_" + id] === true
                ? constants.REPORTED_AUXILLARY
                : constants.REPORTED_NONE;

        const reportedNew = ri | rr | rd | ra;

        let channelData = {
            payload: {
                reportScope: reportedNew,
            },
        };

        const response = await saveChannel(
            context.activePlant.id,
            item.id,
            id,
            channelData
        );
        setChannelArray([]);
        setChannelArray(channelArray);
        console.log("channel_array=>", channelArray);
    };

    const remove = async () => {
        if (
            (await confirm(`Are you sure you want to delete this device?`)) ==
            true
        ) {
            const response = await deleteDevice(
                context.activePlant.id,
                item.id
            );
            if (response && response.result) {
                navigator(`/devices`);
            } else {
                setMessage("Something went wrong.");
                setShowMessage(true);
            }
        }
    };

    const save = async () => {
        if (
            item.hardware_identifier == null ||
            item.hardware_identifier.length == 0
        ) {
            setShowError(true);
            setMessage("Please enter hardware identifier.");
            setShowMessage(true);
            return false;
        } else if (item.name == null || item.name.length == 0) {
            setShowError(true);
            setMessage("Please enter name");
            setShowMessage(true);
            return false;
        }
        const response = await saveDevice(context.activePlant.id, item);
        if (response && response.error && response.error.hardware_identifier) {
            setShowError(true);
            setMessage(response.error.hardware_identifier[0]);
            setShowMessage(true);
        } else {
            navigator(`/devices`);
        }
    };

    return loadingPrimary ? (
        <>
            <Spinner />
            <div className="text-xs d-flex justify-content-center">
                <i className="fa fa-microchip fa-10x"></i>
            </div>
        </>
    ) : (
        <>
            <div className="d-flex justify-content-center">
                {showMessage && (
                    <div
                        className={
                            showError
                                ? "d-flex form-group alert alert-danger"
                                : "d-flex form-group alert alert-success"
                        }
                    >
                        <div className="d-inline-block col-11 inline-block">
                            {message}
                        </div>
                        <div className="d-inline-block col-1 inline-block text-right">
                            <i
                                className="fa fa-times"
                                onClick={() => {
                                    setMessage("");
                                    setShowMessage(false);
                                    setShowError(false);
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>
            {id > 0 && (
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-6">
                            <div class="card card-primary">
                                <div class="card-header">
                                    <h3 class="card-title">
                                        {item?.device_id}
                                    </h3>
                                    <span className="text-sm float-right">
                                        Updated{" "}
                                        {longDateString(item?.updated_at)} by{" "}
                                        {item?.updated_by?.name}
                                    </span>
                                </div>
                                <div class="card-body">
                                    <div className="form-group">
                                        <label htmlFor="device.device_profile">
                                            Device Profile
                                        </label>
                                        <select
                                            className="form-control"
                                            id="device_profile_id"
                                            name="device_profile_id"
                                            value={item?.device_profile_id}
                                            onChange={(e) => {
                                                setItem({
                                                    ...item,
                                                    device_profile_id:
                                                        e.target.value == 0
                                                            ? null
                                                            : e.target.value,
                                                });
                                            }}
                                        >
                                            <option value="0">None</option>
                                            {deviceProfiles.map(
                                                (value, index) => {
                                                    return (
                                                        <option
                                                            key={index}
                                                            value={value.id}
                                                        >
                                                            {value.name}
                                                        </option>
                                                    );
                                                }
                                            )}
                                            ;
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="device.name">
                                            Name
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Name"
                                            defaultValue={item?.name}
                                            onChange={(e) => {
                                                setItem({
                                                    ...item,
                                                    name: e.target.value,
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="device.description">
                                            Description
                                        </label>
                                        <input
                                            type="textarea"
                                            className="form-control"
                                            rows={3}
                                            defaultValue={item?.description}
                                            onChange={(e) => {
                                                setItem({
                                                    ...item,
                                                    description: e.target.value,
                                                });
                                            }}
                                        />
                                    </div>
                                </div>

                                <div class="card-footer">
                                    <button
                                        className="btn btn-info btn-danger text-left"
                                        onClick={async () => {
                                            await remove();
                                        }}
                                    >
                                        Delete
                                    </button>
                                    <button
                                        type="submit"
                                        class="btn btn-primary ml-2 float-right"
                                        onClick={async () => {
                                            await save();
                                        }}
                                    >
                                        Save
                                    </button>
                                    <button
                                        className="btn btn-primary ml-2 float-right"
                                        onClick={async () => {
                                            navigator(`/devices`);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div class="card card-info">
                                <div class="card-header">
                                    <h3 class="card-title">Zones</h3>
                                    <small className="float-right">
                                        Attach the Zones for <b>{item?.name}</b>{" "}
                                        to indicate installations
                                    </small>
                                </div>
                                <div class="card-body">
                                    <div className="row form-group mt-3 ml-1">
                                        <div className="col-lg-10">
                                            <select
                                                className="form-control"
                                                id="zoneId"
                                                name="zoneId"
                                                value={zoneId}
                                                onChange={(e) => {
                                                    setZoneId(e.target.value);
                                                }}
                                            >
                                                <option value="0">
                                                    --Select--
                                                </option>
                                                {unlinkedZones.map(
                                                    (value, index) => {
                                                        return (
                                                            <option
                                                                key={index}
                                                                value={value.id}
                                                            >
                                                                {value.name}
                                                            </option>
                                                        );
                                                    }
                                                )}
                                                ;
                                            </select>
                                        </div>
                                        <div className="col-lg-2">
                                            <div className="">
                                                <a
                                                    id="addZone"
                                                    href="#"
                                                    className={
                                                        editZone === true
                                                            ? "btn btn-info btn-icon-split"
                                                            : "hidden"
                                                    }
                                                    onClick={
                                                        handleAddZoneWithDevice
                                                    }
                                                >
                                                    <span className="icon text-white-50">
                                                        <i className="fa fa-link"></i>{" "}
                                                        Link
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <Paper>
                                        <Grid
                                            rows={linkedZones}
                                            columns={columns}
                                            getRowId={(row) => row.id}
                                        >
                                            {showFilter && <FilteringState />}
                                            <SortingState />
                                            <SelectionState
                                                selection={selected}
                                                onSelectionChange={setSelected}
                                            />
                                            <PagingState
                                                defaultCurrentPage={0}
                                                defaultPageSize={pageSizes[1]}
                                            />

                                            {showFilter && (
                                                <IntegratedFiltering />
                                            )}
                                            <IntegratedSorting />
                                            <IntegratedSelection />
                                            <IntegratedPaging />

                                            <Table
                                                columnExtensions={
                                                    tableColumnExtensions
                                                }
                                                cellComponent={TableCell}
                                            />
                                            <TableColumnVisibility
                                                defaultHiddenColumnNames={
                                                    defaultHiddenColumnNames
                                                }
                                            />
                                            <TableColumnResizing
                                                defaultColumnWidths={
                                                    defaultColumnWidths
                                                }
                                            />
                                            <TableHeaderRow
                                                showSortingControls
                                            />
                                            {showFilter && <TableFilterRow />}
                                            <TableSelection
                                                showSelectionColumn={false}
                                                selectByRowClick
                                                highlightRow
                                            />
                                            <Toolbar />
                                            <ColumnChooser />
                                            <PagingPanel
                                                pageSizes={pageSizes}
                                            />
                                        </Grid>
                                    </Paper>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div class="card card-dark">
                                <div class="card-header">
                                    <h3 class="card-title">Signals</h3>
                                    <small className="float-right">
                                        Modify, calibrate and setup signals for{" "}
                                        <b>{item?.name}</b>
                                    </small>
                                </div>

                                <div class="card-body">
                                    <Paper>
                                        <Grid
                                            rows={channels}
                                            columns={columnsC}
                                            getRowId={(row) => row.id}
                                        >
                                            {showFilterC && <FilteringState />}
                                            <SortingState />
                                            <SelectionState />
                                            <PagingState
                                                defaultCurrentPage={0}
                                                defaultPageSize={pageSizesC[1]}
                                            />

                                            {showFilterC && (
                                                <IntegratedFiltering />
                                            )}
                                            <IntegratedSorting />
                                            <IntegratedSelection />
                                            <IntegratedPaging />

                                            <Table
                                                columnExtensions={
                                                    tableColumnExtensionsC
                                                }
                                                cellComponent={TableCellC}
                                            />
                                            <TableColumnVisibility
                                                defaultHiddenColumnNames={
                                                    defaultHiddenColumnNamesC
                                                }
                                            />
                                            <TableColumnResizing
                                                defaultColumnWidths={
                                                    defaultColumnWidthsC
                                                }
                                            />
                                            <TableHeaderRow
                                                showSortingControlsC
                                            />
                                            {showFilterC && <TableFilterRow />}
                                            <Toolbar />
                                            <ColumnChooser />
                                            <PagingPanel
                                                pageSizes={pageSizesC}
                                            />
                                        </Grid>
                                    </Paper>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {signalUnderCalibration && (
                <SignalCalibrationWizard
                    signalUnderCalibration={signalUnderCalibration}
                    onClose={() => {
                        setSignalUnderCalibration(null);
                    }}
                    onFinish={(manifest) => {
                        console.log("Wizard::finish");
                        setSignalUnderCalibration(null);
                    }}
                ></SignalCalibrationWizard>
            )}
        </>
    );
};

export { Device };
